import React from 'react';
import { Icon } from '../Icon';
import { Timer } from '../Timer';
import styles from './DiscountBlock.css';

function DiscountBlock({ expiryTimestamp, isExpired, onExpirePromo, defaultDiscountText = '', defaultValue = 50, expiresLabel = 'Discount expires in', withTimer = true }) {
    if (withTimer && (!expiryTimestamp || isExpired)) {
        return null;
    }

    const renderText = () => {
        if (!withTimer) {
            return <strong>Limited time offer</strong>;
        }

        if (defaultDiscountText) {
            return <><strong>{defaultDiscountText}</strong> {expiresLabel}</>;
        }

        return <><strong>{defaultValue}%</strong> {expiresLabel}</>;
    };

    return (
        <div className={styles.root}>
            <Icon name='timer' />
            <p className={styles.text}>
                {renderText()}
                {withTimer && <Timer expiryTimestamp={expiryTimestamp} onExpire={onExpirePromo} withDiscount />}
            </p>
        </div>
    );
}

export {
    DiscountBlock
};
